import React, { RefObject } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Controller, Control } from "react-hook-form";
import Checkbox from "app/components/common/inputs/Checkbox";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import Clear from "app/components/common/buttons/Clear";

interface Props {
  title?: string;
  id?: string;
  terms: string;
  sigCanvas: RefObject<SignatureCanvas>;
  clearSignature: () => void;
  signatureError: string | null;
  setSignatureError: (error: string | null) => void;
  control: Control<any>;
}

const DynamicSignature: React.FC<Props> = ({
  title = "Digital Signature",
  sigCanvas,
  clearSignature,
  signatureError,
  setSignatureError,
  control,
  id,
  terms,
}) => {
  return (
    <div className="text-left">
      <div className="flex justify-between mb-2 items-center">
        <h6 className="font-Mulish text-nowrap text-base text-lightBlue mb-2">
          {title}
        </h6>
      </div>

      <div className="relative">
        <Clear onClick={clearSignature} />
        <SignatureCanvas
          ref={sigCanvas}
          onBegin={() => {
            if (signatureError) setSignatureError(null);
          }}
          canvasProps={{
            className:
              "signature-canvas border-2 w-full h-[180px] p-2 rounded-[10px] border-[#EAECF0] mb-2",
          }}
        />
      </div>

      {signatureError && <ErrorsMessage title={signatureError} />}

      <div className="mb-4">
        <Controller
          name={terms}
          control={control}
          rules={{ required: "You must agree to the terms." }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <div className="mb-3 sm:mb-1 text-left">
              <Checkbox
                id={id}
                className="!items-start mt-2"
                removeCheckMargin={true}
                labelHtml={
                  <p className="text-[14px] font-Mulish text-lightBlue">
                    By providing my/our signature below, I/we declare that the
                    information supplied in this application is true and
                    complete to the best of my/our knowledge. I/we understand
                    that this information will be used to assess my/our
                    eligibility for Hejaz Auto Finance. I/we also provide
                    consent for Hejaz to verify the information provided in this
                    application, including conducting checks with external
                    parties, such as credit reporting By providing my/our
                    signature below, I/we declare that the information supplied
                    in this application is true and complete to the best of
                    my/our knowledge. I/we understand that this information will
                    be used to assess my/our eligibility for Hejaz Auto Finance.
                    I/we also provide consent for Hejaz to verify the
                    information provided in this application, including
                    conducting checks with external parties, such as credit
                    reporting
                  </p>
                }
                checked={value}
                onChange={(e) => onChange(e.target.checked)}
              />
              {error && <ErrorsMessage title={error.message} />}
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default DynamicSignature;
